import CardObservations from './CardObservations';
import './CardObservations.scss';

export default CardObservations;
